// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import reset from './assets/css/reset.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import axios from 'axios'
// const httpHead = 'http://srm.xmstm.com.cn/'
//kejiguan.huudon.cn
// const httpHead = 'http://srm.xmstm.com.cn/'
const httpHead = 'http://kejiguan.huudon.cn/'
// 创建一个 Axios 实例
const instance = axios.create({
  baseURL: 'https://api.example.com', // 设置基础 URL
  timeout: 5000, // 设置请求超时时间
});
if (JSON.parse(localStorage.getItem('userInfo')) !== null) {
  // 设置默认请求头
  instance.defaults.headers.common['token'] = JSON.parse(localStorage.getItem('userInfo')).token;
} else {
  instance.defaults.headers.common['token'] = '';

}


Vue.prototype.$axios = instance
Vue.prototype.$httpHead = httpHead
Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  reset,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js